import React from 'react';
import { GiftIcon } from 'lucide-react';
export function BonusSection() {
  return <section className="w-full bg-[#f5f5f5] py-8 md:py-16 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="flex flex-col md:flex-row items-center justify-center gap-3 mb-8 md:mb-12" data-id="element-3">
          <GiftIcon className="w-8 h-8 md:w-10 md:h-10 text-[#c41e3a]" aria-hidden="true" data-id="element-4" />
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 text-center" data-id="element-5">
            Además, accedés a estos 3 bonus exclusivos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-6">
          {/* Bonus 1 */}
          <div className="bg-white rounded-xl overflow-hidden shadow-md border border-gray-200 flex flex-row md:flex-col items-center md:items-stretch" data-id="element-7">
            <div className="w-1/3 md:w-full bg-gray-50 p-3 md:p-6 flex justify-center items-center border-r md:border-r-0 md:border-b border-gray-100" data-id="element-8">
              <img src="https://cdn.magicpatterns.com/uploads/cGJpTmyHPbpqPGVXxewqK8/bonus_1.png" alt="Bonus 1: Guía de herramientas recomendadas" className="w-full max-w-[100px] md:max-w-[160px] h-auto object-contain drop-shadow-md" data-id="element-9" />
            </div>
            <div className="w-2/3 md:w-full p-4 md:p-6 flex flex-col justify-center" data-id="element-10">
              <div className="text-[#c41e3a] font-black text-xs tracking-widest mb-1 md:mb-2 uppercase" data-id="element-11">
                Bonus 1
              </div>
              <h3 className="text-gray-900 font-black text-sm md:text-lg mb-1 md:mb-2 leading-tight" data-id="element-12">
                Guía de Herramientas
              </h3>
              <p className="text-gray-600 text-xs md:text-sm leading-relaxed hidden md:block" data-id="element-13">
                Descubrí exactamente qué herramientas necesitás para empezar sin
                gastar de más.
              </p>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white rounded-xl overflow-hidden shadow-md border border-gray-200 flex flex-row md:flex-col items-center md:items-stretch" data-id="element-14">
            <div className="w-1/3 md:w-full bg-gray-50 p-3 md:p-6 flex justify-center items-center border-r md:border-r-0 md:border-b border-gray-100" data-id="element-15">
              <img src="https://cdn.magicpatterns.com/uploads/oittqwoA4ccTaW6GaGFjDn/bonus_2.png" alt="Bonus 2: Errores más comunes del barbero principiante" className="w-full max-w-[100px] md:max-w-[160px] h-auto object-contain drop-shadow-md" data-id="element-16" />
            </div>
            <div className="w-2/3 md:w-full p-4 md:p-6 flex flex-col justify-center" data-id="element-17">
              <div className="text-[#c41e3a] font-black text-xs tracking-widest mb-1 md:mb-2 uppercase" data-id="element-18">
                Bonus 2
              </div>
              <h3 className="text-gray-900 font-black text-sm md:text-lg mb-1 md:mb-2 leading-tight" data-id="element-19">
                Los 10 Errores Comunes
              </h3>
              <p className="text-gray-600 text-xs md:text-sm leading-relaxed hidden md:block" data-id="element-20">
                Evitá los errores que te hacen perder clientes cuando recién
                empezás.
              </p>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white rounded-xl overflow-hidden shadow-md border border-gray-200 flex flex-row md:flex-col items-center md:items-stretch" data-id="element-21">
            <div className="w-1/3 md:w-full bg-gray-50 p-3 md:p-6 flex justify-center items-center border-r md:border-r-0 md:border-b border-gray-100" data-id="element-22">
              <img src="https://cdn.magicpatterns.com/uploads/9y1VLYc2fxYSx5JzpC7hMJ/bonus_3.png" alt="Bonus 3: Cómo conseguir clientes y generar ingresos" className="w-full max-w-[100px] md:max-w-[160px] h-auto object-contain drop-shadow-md" data-id="element-23" />
            </div>
            <div className="w-2/3 md:w-full p-4 md:p-6 flex flex-col justify-center" data-id="element-24">
              <div className="text-[#c41e3a] font-black text-xs tracking-widest mb-1 md:mb-2 uppercase" data-id="element-25">
                Bonus 3
              </div>
              <h3 className="text-gray-900 font-black text-sm md:text-lg mb-1 md:mb-2 leading-tight" data-id="element-26">
                Conseguir Clientes
              </h3>
              <p className="text-gray-600 text-xs md:text-sm leading-relaxed hidden md:block" data-id="element-27">
                Estrategias probadas para atraer clientes y generar ingresos
                desde el día uno.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}